import React from "react";
import PaymentSchedulesPageGen from "./generated/PaymentSchedulesPageGen";
import paymentSchedulesService from "../../../services/legacy/paymentSchedulesService";

const SHOW_IN_GRID = new Set(["name", "description"]);
const SHOW_IN_FILTER = new Set(["name", "description"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const PaymentSchedulesPage = () => {
  const service = paymentSchedulesService;
  return <PaymentSchedulesPageGen service={service} transformColumns={transformColumns} />;
};

export default PaymentSchedulesPage;